import React, { useEffect, useState, useRef } from "react";
import { styled } from "styled-components";
import axios from "axios";

import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";

import Slider from "react-slick";
import AutoSlideImage from "./AutoSlideImage";
import { ListProjectImagesApi } from "../../axios/api";

const projectCache = {
  data: null,
};

function CustomProjectSlider() {
  const [projectsData, setProjectsData] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);


  const navigate = useNavigate();

  useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);

  // ✅ CACHE CHECK
  if (projectCache.data) {
    setProjectsData(projectCache.data);
    return;
  }

  axios
    .get(ListProjectImagesApi)
    .then((response) => {
      const { data, StatusCode } = response.data.app_data;

      if (StatusCode === 6000) {
        const result = [...data].reverse();
        setProjectsData(result);
        projectCache.data = result; // ✅ store in cache
      } else {
        setProjectsData([]);
      }
    })
    .catch(console.error);

  return () => window.removeEventListener("resize", handleResize);
}, []);
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "linear",
  };

  return (
    <Section>
      <Container>
        <BreadCrumb>Projects /</BreadCrumb>

        {/* ================= MOBILE ================= */}
        {width < 580 ? (
          <Slider {...settings} className="mobileSlider">
            {projectsData.map((obj, index) => (
              <MobSlider key={obj.id || index} className="innerArea">
                <Wrapper>
                  <ProjectHighlight>
                    <AutoSlideImage assets={obj?.project_images} />
                  </ProjectHighlight>

                  <SideBar>
                    <SmallPreview>
                      <img
                        loading="lazy"
                        src={obj?.project_images?.[1]?.resized_image}
                        alt=""
                      />
                    </SmallPreview>

                    <SmallPreview>
                      <img
                        loading="lazy"
                        src={obj?.project_images?.[2]?.resized_image}
                        alt=""
                      />
                    </SmallPreview>

                    <SmallPreview last={1}>
                      <img
                        loading="lazy"
                        src={obj?.project_images?.[3]?.resized_image}
                        alt=""
                      />
                      <p onClick={() => navigate(`/project/${obj.slug}`)}>
                        View <br /> More
                      </p>
                    </SmallPreview>
                  </SideBar>
                </Wrapper>

                <ClientInfo>
                  <p>{obj?.title}</p>
                </ClientInfo>
              </MobSlider>
            ))}
          </Slider>
        ) : (
          <>
            {/* ================= DESKTOP (SAFE LAYOUT) ================= */}
            <SliderArea>
              {projectsData.slice(0, 6).map((project, index) => (
                <OneProject
                  key={project.id || index}
                  className={
                    ["one", "two", "three", "four", "five", "six"][index]
                  }
                  onClick={() => navigate(`/project/${project.slug}`)}
                >
                  {index % 2 === 0 ? (
                    <>
                      <ImgDiv
                        img={project?.project_images?.[0]?.image || ""}
                      />
                      <Title>
                        {project?.title?.split(" for ")[1] ||
                          project?.title}
                      </Title>
                    </>
                  ) : (
                    <>
                      <Title>
                        {project?.title?.split(" for ")[1] ||
                          project?.title}
                      </Title>
                      <ImgDiv
                        img={project?.project_images?.[0]?.image || ""}
                      />
                    </>
                  )}
                </OneProject>
              ))}
            </SliderArea>

            <ViewMore>
              <p onClick={() => navigate("/projects")}>
                View More <EastIcon />
              </p>
            </ViewMore>
          </>
        )}
      </Container>
    </Section>
  );
}

export default CustomProjectSlider;

/* ================= STYLES ================= */

const Section = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 25px 0px;
`;

const Container = styled.div`
  width: 87%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 93%;
  }

  @media (max-width: 1875px) {
    .five,
    .six {
      display: none;
    }
  }

  @media (max-width: 1325px) {
    .five,
    .six,
    .four {
      display: none;
    }
  }

  @media (max-width: 968px) {
    width: 95%;
  }

  @media (max-width: 580px) {
    .five,
    .six,
    .four,
    .three {
      display: none;
    }
  }
`;

const SliderArea = styled.div`
  display: flex;
  div {
    margin: 0px 3px;
  }
`;

const OneProject = styled.div`
  display: flex;
  flex-direction: column;
  height: 475px;
  width: 350px;
  cursor: pointer;
`;

const ImgDiv = styled.div`
  width: 100%;
  ${(props) =>
    props.img && `background:url(${props.img}) 50% 50% no-repeat`};
  height: 100%;
  background-size: cover;
`;

const Title = styled.div`
  display: flex;
  font-size: 15px;
  font-family: "raleway_regular";
  padding: 10px 2px;
  opacity: 1;
`;

const BreadCrumb = styled.div`
  padding: 30px 10px;
  width: 75%;
  font-family: "raleway_light";
  font-size: 15px;
`;

const ViewMore = styled.div`
 display: flex;
  width: 100%;
  margin: 10px 0;
  justify-content: flex-end;
  padding-right: 10px; 

  p {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-family: "raleway_light";
    cursor: pointer;
  }
`;

const MobSlider = styled.div`
  display: flex !important;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  height: 375px;
`;

const ProjectHighlight = styled.div`
  width: 65%;
`;

const SideBar = styled.div`
  width: 35%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SmallPreview = styled.div`
  width: 83%;
  height: 30%;
  position: relative;
  cursor: pointer;

  ${(props) =>
    props.last &&
    `
    &::after{
      content:'';
      position:absolute;
      inset:0;
      background:var(--primary-cl);
      opacity:.7;
    }
  `}

  img {
    width: 100%;
    height: 100%;
  }

  p {
    position: absolute;
    top: 13%;
    color: #fff;
    font-size: 17px;
    text-align: center;
    cursor: pointer;
  }
`;

const ClientInfo = styled.div`
  p {
    text-align: center;
    font-size: 14px;
    font-family: "raleway_regular";
  }
`;
